import styles from '../../styles/Podcast.module.css';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/fontawesome-free-regular';
import { Button } from 'react';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
//import IconButton from '@fortawesome/fontawesome-free-regular'; // @material-ui/core/IconButton
//import MoreVertIcon from '@fortawesome/fontawesome-free-regular';


const PodcastItemRow = ({ innerRef, index, image, item, history, ariaOwns, selected, onClick, onOverflowButtonClick }) => {

    function formatTimeZh(seconds) {
        const date = new Date(seconds * 1000)
        const hh = date.getUTCHours();
        const mm = date.getUTCMinutes() + (date.getUTCSeconds() > 0 ? 1 : 0);

        return `${hh ? hh + " 小時 " : ""}${mm} 分鐘`
    }

    function formatSubtitle() {
        if (item.subtitle && item.description) {
            return item.subtitle + '；' + item.description;
        }
        else {
            return item.subtitle + '' + item.description;
        }
    }


    function renderItemDurationAndRemainBar() {
        let playedTime = history == null ? 0 : history.pos;
        let duration = Math.floor(item.duration);
        let playCount = 0;
        if (history && history.serverCount) playCount += history.serverCount;
        if (history && history.localCount) playCount += history.localCount;

        // never played yet
        if (playedTime == 0 && playCount == 0) {
            return (
                <div>{formatTimeZh(duration)}</div>
            );
        }
        else {
            // last time play to end 
            if (playedTime == 0) {
                let numText = playCount > 1 ? '（' + playCount + '次）' : '';

                return (
                    <div>已播放{numText}</div>
                );
            }
            // last time played but not finished
            else {
                // at least show a dot of purple even it is less than 1%
                let percent = Math.max(1, playedTime * 100 / duration) + '%';

                return (
                    <div>
                        <div className={styles.remiainBarContainer}>
                            <div className={styles.remiainBar} style={{ width: percent }} />
                        </div>
                        <div className={styles.remainBarText}>
                            剩餘 {
                                formatTimeZh(duration - playedTime)
                            }
                        </div>
                    </div>
                );
            }
        }
    }

    return (
        typeof item == 'undefined' ? <></> :
            <div
                ref={ref => innerRef(ref)}
                className={(selected ? styles.podcastPlaylistRowSelected : styles.podcastPlaylistRow)}
                onClick={onClick}>
                <Container fluid>
                    <Row>
                        <Col xs={3} sm={2} md={2} lg={2} style={{padding:5}}>
                            <Image
                                className={styles.rowImage}
                                src={image}
                                alt="圖片"
                                sizes="100vw"
                                height={0}
                                width={0}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        </Col>
                        <Col xs={8} sm={9} md={9} lg={9} className={`col align-self-center`} >
                            <Row className={styles.podcastPlaylistTitle}>{item.title}</Row>
                            <Row className={styles.podcastPlaylistSubtitle}>{formatSubtitle()}</Row>
                            <Row className={styles.podcastPlaylistDate}>{item.publish_date}</Row>
                            <Row className={styles.podcastPlaylistDuration}>
                                <Col xs={2} sm={2} md={1} lg={1} className={`col align-self-center`} style={{padding:0}}>
                                    <div className={styles.podcastPlaylistPlayBtn}><FontAwesomeIcon icon={faPlayCircle} className={styles.playIcon} /></div>
                                </Col>
                                <Col xs={10} sm={10} md={11} lg={11} className={`col align-self-center`} style={{padding:0}}>
                                    {renderItemDurationAndRemainBar()}
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={1} sm={1} md={1} lg={1} className={`${styles.podcastPlayItemCol3} col align-self-center`} >
                            <IconButton
                                aria-label="More"
                                aria-owns={ariaOwns}
                                aria-haspopup="true"
                                index={index}
                                onClick={(e) => onOverflowButtonClick(e)}>
                                <MoreVertIcon />
                            </IconButton>
                        </Col>
                    </Row>
                </Container>
            </div>
    );
}

export default PodcastItemRow;